import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import "../App.css";
import { IconContext } from "react-icons";
import { logo } from "../assets/svg/svg.js"
import "../components/styles/navbar.css"
import Cookies from "universal-cookie";
import { getHostContract, getHostHelperContract, getSuggestion } from "../helper/contract-helper.js";
import { formatMessageList, getWeb2emails, formatEmailDetails } from "../helper/dataFormatHelper.js";
import { deleteEmails, getEmails, updateAttribute, updateEmailAttributeValue } from "../helper/emailHelper.js";
import { CompleteLoader, CreateFolderModal, QuickSendModal } from "../modals/common-alert.js";
import { CreateEvent } from "../modals/CreacteEvent.js";
import { folders } from "../assets/svg/folder-svg.js";
import { useDispatch, useSelector } from "react-redux";
import contant from "../constants/constants.json";
import config from "../web3/web3Config.json";
import { transactionAction } from "../helper/chain-helper.js";
import { getInsecure, updateInsecureMail } from "../service/api-actions";
import { Tooltip } from 'antd';
import Swal from 'sweetalert2';
import { requireAuth } from '../authMiddleware.js';

import { getSingnature, decodeHtml, getBlockedList } from "../helper/settingsHelper.js";
import { getGeneralSettings } from '../helper/settingsHelper.js';
import { reportError, toErrorString } from "../utils/errorLogger.js";
import { notifyChainFailure } from "../utils/txFeedback.js";
const cookies = new Cookies();

function Navbar() {

  const history = useNavigate();
  const dispatch = useDispatch();
  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  const isCompose = useSelector((state) => state.isCompose);
  const refreshSettings = useSelector((state) => state.refreshSettings);
  const selectedMessage = useSelector((state) => state.selectedMessage);
  const [activeIndex, setActiveIndex] = useState(0);
  const [quick, setAddQuick] = useState(false);
  const [user] = useState(cookies.get("userObject"));
  const [indexCount, setIndexCount] = useState(0);
  const [insecureCount, setInsecureCount] = useState(0);
  const [sentCount, setSentCount] = useState(0);
  const [trashCount, setTrashCount] = useState(0);
  const [folderList, setFolderList] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [quickUserList, setQuickUserList] = useState([]);
  const [folderModal, setFolderModal] = useState(false);
  const [activeFolderIndex, setFolderActiveIndex] = useState(null);
  const [loader, setLoader] = useState(false);
  const [text, setText] = useState("")
  const [isQuickAccessEdit, setIsQuickAccessEdit] = useState(false);
  const [isInsecure, setIsInsecure] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isScreenSmall, setIsScreenSmall] = useState(window.innerWidth < 1170);
  const [showDeleteIcon, setShowDeleteIcon] = useState(null);
  const [isOpenEvent, setIsOpenEvent] = useState(false);
  const folderUpdate = useSelector((state) => state.folderUpdate)
  const pathName = window.location.pathname;
  const userName = localStorage.getItem('UserName');

  const handleDivClick = async (index, itemValue) => {
    dispatch({ type: "SELECT_MESSAGE", payload: !selectedMessage });
    dispatch({ type: "SELECT_TYPE", payload: null });
    setFolderActiveIndex(index);
    fetchData();
    setActiveIndex("");
    dispatch({ type: "FOLDER_INDEX", payload: index });
    localStorage.setItem('selectedFolderId', itemValue.id)
    history("/folders");
  };
  const triggerNewEvent = () => {
    setIsOpenEvent(true);
  }

  useEffect(() => {
    window.addEventListener('NEW_EVENT', triggerNewEvent);
    window.addEventListener('REFRESH_COUNT', setCountData)
    return () => {
      window.removeEventListener('NEW_EVENT', triggerNewEvent);
      window.removeEventListener('REFRESH_COUNT', setCountData)
    };
  }, []);

  useEffect(() => {
    if (window.ncogProvider) {
      window.ncogProvider.on('accountsChanged', (accounts) => {
        requireAuth()
      });
    }
  }, [])

  useEffect(() => {
    const pageType = pathName.replace("/app", "");
    if (pageType === "folders") {
      setActiveIndex(0);
      history("/inbox");
    }
    getCountByType();
    fetchData();
    fetchSettings();
  }, []);


  const handleWindowResize = () => {
    const screenIsSmall = window.innerWidth < 1170;
    setIsScreenSmall(screenIsSmall);

    if (!screenIsSmall) {
      document.body.classList.remove("leftsidebar-toggle-menu");
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const handleClickOutsideSidebar = (e) => {
    if (!e.target.closest("#leftsidebar") && !e.target.closest(".bars") && e.target.classList.contains("overlay")) {
      if (isScreenSmall) {
        setIsSidebarOpen(false);
        document.body.classList.remove("leftsidebar-toggle-menu");
      }
    }
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add("leftsidebar-toggle-menu");
      document.addEventListener("click", handleClickOutsideSidebar);
    } else {
      document.body.classList.remove("leftsidebar-toggle-menu");
      document.removeEventListener("click", handleClickOutsideSidebar);
    }

    return () => {
      document.removeEventListener("click", handleClickOutsideSidebar);
    };
  }, [isSidebarOpen, isScreenSmall]);

  const handleOverlayClick = () => {
    document.body.classList.remove("leftsidebar-toggle-menu");
  };
  useEffect(() => {
    fetchSettings();
  }, [refreshSettings]);

  useEffect(() => {
    const pageType = pathName.replace("/app", "");
    const pageIndex = contant.pageType[pageType];
    if (pageIndex) {
      setActiveIndex(pageIndex);
    }
  }, [pathName]);

  async function fetchSettings() {
    try {
      const settingsJson = await getGeneralSettings();
      const insecure = settingsJson.isWeb2Inbox;
      setIsInsecure(insecure);
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Navbar.js, Fun: fetchSettings, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      return false;
    }
  }

  async function fetchData() {
    try {
      const helperContract = await getHostHelperContract();
      const filteredAddressBook = await getSuggestion();
      const folders = await helperContract.methods.getFolders(user.name).call();
      const usersQuickSend = await helperContract.methods.getUsersQuickSend(user.name).call();
      setQuickUserList(usersQuickSend);
      setAddressList(filteredAddressBook);
      setFolderList(folders);
      dispatch({ type: "FOLDERS_LIST", payload: folders })
      dispatch({ type: "ADDRESS_LIST", payload: filteredAddressBook });
    }
    catch (err) {
      const errorStr = toErrorString(err || err.message);
      reportError({
        endpoint: '-',
        message: `FileName: Navbar.js, Fun: fetchData, ${String(err.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.error(err)
    }

  }



  useEffect(() => {
    fetchData()
  }, [folderUpdate])

  async function setCountData() {
    getCountByType();
  }
  const getCount = useSelector((state) => state.refreshCount);
  useEffect(() => {
    setCountData();
  }, [getCount]);

  async function getEmailCount() {
    try {
      const emailList = await getEmails(user.name);
      const updatedEmailList = await formatEmailDetails(emailList);
      
      const filteredEmailList = updatedEmailList
        .filter(({ senderName }) => senderName)
        .map(({ id, subject, encryptedData, receivedDate, isStarred, senderName, isRead, emailDetails, isCC, isBCC, ...rest }) => ({
          id: parseInt(id),
          subject,
          encryptedData,
          receivedDate,
          created_at: receivedDate,
          isStarred: isStarred,
          sender: senderName,
          isRead,
          header: emailDetails,
          isCC,
          isBCC,
          mailtype: "web3emails",
          ...rest
        }))
        .filter(data => data.attributes)
        .filter(data => !data.attributes.value && !data.isDeleted && !data.isArchive && (data.isfolder === "false" || !data.isfolder) && !data.isSaved);
      
      return await formatMessageList(filteredEmailList);
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Navbar.js, Fun: getEmailCount, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      return null;
    }
  }

  async function getCountByType() {
    try {
      const inboxUnreadCount = await getEmailCount();
      const unReadInboxCount = inboxUnreadCount?.unReadList.length || 0;
      const response = await getWeb2emails(user.name);      
      const getBlocked = await getBlockedList();
      const blockedAddresses = getBlocked.address ? getBlocked.address.split(',') : [];
      
      let sentEmailsCount = 0;
      let trashEmailsCount = 0;
      
      const unreadEmailList = response.filter((data) => {
        if (blockedAddresses.includes(data.sender)) {
          return false;
        }
        
        const isSentFolder = data.folder && data.folder.toLowerCase().includes('sent');
        const isTrashFolder = data.folder && data.folder.toLowerCase().includes('trash');
        
        if (isSentFolder) {
          sentEmailsCount++;
        }
        
        if (isTrashFolder || data.delete === 1) {
          trashEmailsCount++;
        }
        
        const passes = data.isArchive === false && 
                       (data.delete === 0 || data.delete === 2) && 
                       data.isfolder === false && 
                       data.isRead === false && 
                       !isSentFolder && 
                       !isTrashFolder
        return passes;
      }).length || 0
      
      
      const totalSentEmails = sentEmailsCount;
      const totalTrashEmails = trashEmailsCount;
      
      setInsecureCount(unreadEmailList);
      setIndexCount(unReadInboxCount);
      setSentCount(totalSentEmails);
      setTrashCount(totalTrashEmails);
    } catch (err) {
      console.log(err);
    }
  }


  function returnCountValue(index) {
    const returnArray = [indexCount, insecureCount, sentCount, 0, 0, 0, 0, trashCount];
    return returnArray[index];
  }

  function refreshBoxByType() {
    dispatch({ type: "REFRESH_MESSAGE", payload: !getRefreshMessage });
    setCountData();
  }

  function closeQuickUser() {
    setAddQuick(false);
    setFolderModal(false);
    fetchData();
  }

  function closeEvent() {
    setIsOpenEvent(false)
  }

  function getColorFromJson(jsonString) {
    try {
      const json = jsonString;
      const color = json.folderProperties.find(value => value.key == 'color')['value']
      return color;
    } catch (error) {
      return "green";
    }
  }

  const handleDrop = async (e, folderName) => {
    e.preventDefault();
    setLoader(true);
    setText("Please wait, your email is being moved to the folder, Going forward it will be fast.")
    const id = e.dataTransfer.getData('message_id');
    const messageType = e.dataTransfer.getData('message_type');
    try {
      if (messageType === "Inbox") {
        if (id && messageType) {
          const ok = await updateEmailAttributeValue(user.name, [id], [{ key: 'folder', value: (folderName.id).toString() }], 'hostContract')
          if (!ok) notifyChainFailure(`move this email to "${folderName.name || 'that folder'}"`);
        }
      }
      else if (messageType === "Insecure") {
        const emailID = [id]
        const type = `inbox-folder-${parseInt(folderName.id)}`
        const formattedresponse = await getWeb2emails(user.name)
        const result = formattedresponse.map((data) => {
          const response = emailID.includes(data.id) && data.physmessage_id
          return response;
        }).filter(Boolean);
        await updateAttribute(user.name, result, type, 'folder', true);
      }
    }
    catch (err) {
      const errorStr = toErrorString(err || err.message);
      reportError({
        endpoint: '-',
        message: `FileName: Navbar.js, Fun: handleDrop, ${String(err.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.error(err);
    }
    finally {
      dispatch({ type: "REFRESH_MESSAGE", payload: !getRefreshMessage });
      setLoader(false);
      setText("")
    }
  };

  const allowDrop = (e) => {
    e.preventDefault();

  };



  async function renderPage() {
    getCountByType();
    fetchData();

  }


  async function deleteQuickAccess(index) {
    setText("Please wait, your quick send user is being deleted.")
    setLoader(true);
    const host = getHostHelperContract();
    const functionParams = [user.name, index];
    const hash = await transactionAction(host, "deleteQuickSendEntry", functionParams, user.wallet, 'helper');
    await renderPage();
    setLoader(false);
    setText("")
    if (!hash) notifyChainFailure('remove that Quick Send contact');
  }

  const deleteFolderMessage = async (id) => {
    Swal.fire({
      text: "Are you sure you want to delete the folder and all its contents to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1677ff",
      cancelButtonColor: "#7f7f7f",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: "compose-sweet-alert"
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        setText("Please wait, your folder is being deleted, Going forward it will be fast.")
        const helperContract = getHostHelperContract();
        const functionParams = [user.name, parseInt(id)];
        const hash = await transactionAction(helperContract, "deleteFolder", functionParams, user.wallet, 'helper');
        await renderPage();
        setLoader(false);
        setText("")
        if (!hash) {
          // Don't navigate away as if it worked — the folder is still there.
          notifyChainFailure('delete that folder');
          return;
        }
        history('/inbox');
      }
    });
  }

  const singnature = async () => {
    const signatureData = await getSingnature();
    if (signatureData.signature && !localStorage.getItem("sendingEmail")) {
      const decodedSignature = signatureData.isHtml ? decodeHtml(signatureData.signature) : signatureData.signature;
      localStorage.setItem("sendingEmail", `<div>
        <p><br></p> 
        <p><br></p>
        ${decodedSignature}
      </div>`)
    } else {
      localStorage.setItem("sendingEmail", '')
    }
  }



  return (
    <>
      <IconContext.Provider value={{ color: "undefined" }}>
        <aside id="leftsidebar" className={`sidebar nav-menu ${isSidebarOpen ? 'open' : ''}`}>
          <div className="nav-menu-items">
            <div className="navbar-toggle">
              <div className="logo-content cursor-pointer" onClick={() => {
                history("/inbox")
                setActiveIndex(0)
              }}>
                {logo.dmail_logo_svg}
                <h4 className="dmail-content-h4"> {logo.dmail_name_svg} </h4>
              </div>
            </div>
            <div className="account-div-content">
              <div className="account-sec-navbar">
                <span>Account</span>
                <h3>{`${user.name}`}</h3>
              </div>
              <div className="compose-sec-navbar" id="compose">
                <button className="compose-gradient-btn" onClick={async () => {
                  if (!isCompose) {
                    localStorage.setItem("recipient", '');
                    localStorage.setItem("topic", '');
                    localStorage.setItem("cc", '')
                    localStorage.setItem("bcc", '');
                    await singnature();
                  }
                  dispatch({ type: "IS_COMPOSE", payload: true })
                }}>
                  {logo.compose_btn_svg}
                  <div className="compose-gradient-btn-child">
                    <span className="new-msg-font">Compose</span>
                    {/* <span>(Gas 0.005 {config.SYMBOL})</span> */}
                  </div>
                </button>
              </div>
            </div>
            <div className="class-scroll-bar-navbar" id="style-2" >
              <div className="message-type" >
                <div className="menu-header-data">
                  <span className="menu-type-header">Menu</span>
                </div>
                <ul className="p-0">
                  {SidebarData.map((item, index) => {
                    if (!isInsecure && item.title === "Web2 Inbox") {
                      return null;
                    }
                    const isActive = activeIndex === index;
                    const linkClass = isActive ? `${item.cName} activated` : `${item.cName} in-activated`;
                    const handleDragOver = (e) => {
                      e.preventDefault();
                    }
                    const handleDrop = async (e, title) => {
                      e.preventDefault();
                      const emailType = e.dataTransfer.getData("message_type");
                      const emailId = e.dataTransfer.getData('message_id')
                      if (title === "Trash") {
                        try {
                          setLoader(true)
                          if (emailType === "Inbox") {
                            await deleteEmails(null, [emailId], null, null, emailType, null)
                          }
                          else if (emailType === "Insecure") {
                            const type = "bulkdelete";
                            const response = {
                              id: emailId,
                              value: 1
                            }
                            await updateInsecureMail(type, "", [response]);
                          }
                        }
                        catch (err) {
                          const errorStr = toErrorString(err || err.message);
                          reportError({
                            endpoint: '/updateInsecureMail',
                            message: `FileName: Navbar.js, Fun: handleDrop, ${String(err.message || 'Unhandled error')}`,
                            error: errorStr,
                            userName: userName || '',
                          });
                          console.error(err)
                        }
                        finally {
                          dispatch({ type: "REFRESH_MESSAGE", payload: !getRefreshMessage });
                          setLoader(false)
                        }
                      }
                    }
                    return (
                      <Tooltip key={`tooltip_${index}`} title={item.title} placement="right">
                        <li key={`menu_${index}`} className={linkClass} id={item.id} onDrop={(e) => { handleDrop(e, item.title) }}
                          onDragOver={item.dragging ? handleDragOver : null}
                        >
                          {isActive && <div className="dummy-border-append"> </div>}
                          <Link to={item.path} className={`${item.cName}-a-tag`} onClick={() => {
                            dispatch({ type: "SELECT_MESSAGE", payload: !selectedMessage });
                            dispatch({ type: "SELECT_TYPE", payload: null });
                            setFolderActiveIndex(""); setActiveIndex(index);
                          }} >
                            <div className="d-flex align-items-center gap-2 justify-content-between w-100">
                              <div className="d-flex align-items-center gap-2">
                                <div className="icon-div">{logo[`${item.icon}_logo_svg`]}</div>
                                <span className="white-space-nowrap">{item.title}</span>
                              </div>
                              <div className={`col d-flex align-items-center justify-content-end gap-10 ${returnCountValue(index) === 0 ? 'col-custom-nav-width' : ''}`}>
                                {isActive &&
                                  <div onClick={() => refreshBoxByType(item.title)}>
                                    {logo.reload_svg}
                                  </div>
                                }
                                {!isActive &&
                                  <div className=""></div>
                                }
                                {returnCountValue(index) > 0 && (
                                  <span className="count-type">{returnCountValue(index)}</span>
                                )}
                              </div>
                            </div>
                          </Link>
                        </li>
                      </Tooltip>
                    );
                  })}
                </ul>
                <div className="nav-text d-flex d-md-none mobile-settings">
                  <div className={` mobile-settings d-flex d-md-none align-items-center gap-3 cursor-pointer ${pathName === '/settings' ? 'active' : ''}`} onClick={() => {
                    history("/settings")
                  }}>
                    {logo.setting_logo_svg}
                    <div className="sidenav-folder-content d-flex justify-content-between align-item-center">
                      <p className="text-break mb-0">Settings</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="message-type">
                <div className="menu-header-data">
                  <span className="menu-type-header">Quick Send to : <span className="type-num-count">{quickUserList.length}</span> </span>
                  {quickUserList.length > 0 && (
                    <button className="edit-list-bth" onClick={() => {
                      setIsQuickAccessEdit(!isQuickAccessEdit);
                    }}>
                      {isQuickAccessEdit ? "Close" : "Edit List"}
                    </button>
                  )}
                </div>
                <div className="quick-access-content">
                  {quickUserList.length > 0 && quickUserList.map((itemValue, keyIndex) => (
                    <div key={keyIndex} className="div-class-foot-quick-child cursor-pointer" onClick={() => {
                      if (!isCompose) {
                        localStorage.setItem("recipient", itemValue.userEmail);
                      }
                      dispatch({ type: "IS_COMPOSE", payload: true })
                    }} >
                      <div className="circle-add-user"> {itemValue.userName[0].toUpperCase()} </div>
                      <div className="close-icon-quick-access-ele position-relative-cls">
                        <div className="quick-user name"> {itemValue.userName} </div>
                        <div className="quick-user email"> {itemValue.userEmail} </div>

                        {isQuickAccessEdit &&
                          <div className="close-icon-quick-access position-absolute-cls" onClick={(e) => {
                            e.stopPropagation();
                            deleteQuickAccess(keyIndex)
                          }} > x </div>
                        }
                      </div>
                    </div>
                  ))}
                  <div className="div-class-foot-quick-child cursor-pointer" onClick={() => {
                    fetchData();
                    setAddQuick(true);
                  }}>
                    <div className="circle-add-user">+</div>
                    <span className="add-new-user-span">Add New </span>
                  </div>
                </div>
              </div>
              <div className="message-type">
                <div className="menu-header-data">
                  <span className="menu-type-header">Folder :  <span className="type-num-count">{folderList.length}</span> </span>
                  <button className="edit-list-bth" onClick={() => {
                    setFolderModal(true)
                  }} > Create </button>
                </div>
                <div className="folder-content">
                  {folderList.length > 0 && folderList.map((itemValue, keyIndex) => (
                    <div key={keyIndex}
                      onDrop={(e) => {
                        handleDrop(e, itemValue)
                      }}
                      onDragOver={allowDrop}
                      className={`div-class-folder-content cursor-pointer ${keyIndex === activeFolderIndex ? 'active' : ''}`}
                      onClick={() => handleDivClick(keyIndex, itemValue)}
                      onMouseEnter={() => setShowDeleteIcon(keyIndex)} onMouseLeave={() => setShowDeleteIcon(null)}
                    >
                      <div className="folder-common-element"  >
                        {folders.folderIcon[`${getColorFromJson(itemValue)}Folder`]}
                        <div className="sidenav-folder-content d-flex justify-content-between align-item-center"> <p className="text-break w-200px mb-0">{itemValue.name}</p> {showDeleteIcon === keyIndex && <Tooltip title="Delete"><span className="mt-2" onClick={(e) => { e.stopPropagation(); deleteFolderMessage(itemValue.id) }}>{logo.trash_logo_svg_2}</span></Tooltip>}</div>
                      </div>
                    </div>
                  ))}
                  {/* <div className="div-class-foot-quick-child cursor-pointer" onClick={() => {
                    setFolderModal(true)
                  }}>
                    <div className="circle-add-user">+</div>
                    <span className="add-new-user-span">Add New Folder</span>
                  </div> */}


                </div>

              </div>
            </div>
          </div>
          <CompleteLoader isOpen={loader} text={text} />
          <QuickSendModal isOpen={quick} addressList={addressList} quickUserList={quickUserList} close={() => { closeQuickUser() }} />
          <CreateFolderModal isOpen={folderModal} close={() => { closeQuickUser() }} />
          <CreateEvent isOpen={isOpenEvent} close={() => { closeEvent() }} />
          <div className="overlay" onClick={handleOverlayClick} />
        </aside>
      </IconContext.Provider >
    </>
  );
}
export default Navbar;
